/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  /* Base ":host" styles for the component */
  box-sizing: border-box;
  background-color: var(--calcite-color-foreground-1);
  color: var(--calcite-color-text-2);
  font-size: var(--calcite-font-size--1);
}
:host * {
  box-sizing: border-box;
}

/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-shell-tip-spacing: The left and right spacing of the `calcite-tip-manager` when slotted in the component.
*/
:host {
  position: absolute;
  inset: 0px;
  display: flex;
  block-size: 100%;
  inline-size: 100%;
  flex-direction: column;
  overflow: hidden;
  --calcite-shell-tip-spacing: 26vw;
}

.main {
  position: relative;
  display: flex;
  block-size: 100%;
  inline-size: 100%;
  flex: 1 1 auto;
  flex-direction: row;
  justify-content: space-between;
  overflow: hidden;
}

.content {
  display: flex;
  block-size: 100%;
  inline-size: 100%;
  flex-direction: column;
  flex-wrap: nowrap;
  overflow: auto;
  justify-content: space-between;
}

.content ::slotted(calcite-shell-center-row),
.content ::slotted(calcite-panel),
.content ::slotted(calcite-flow) {
  flex: 1 1 auto;
  align-self: stretch;
  max-block-size: unset;
}

.content--behind {
  position: absolute;
  inset: 0px;
  border-width: 0px;
  z-index: calc(var(--calcite-z-index) - 1);
  display: initial;
}

.content--non-interactive {
  pointer-events: none;
  display: flex;
  block-size: 100%;
  inline-size: 100%;
  flex-direction: column;
  flex-wrap: nowrap;
}

::slotted(calcite-shell-center-row) {
  inline-size: unset;
}

::slotted(.header .heading) {
  font-size: var(--calcite-font-size--2);
  line-height: 1.375;
  font-weight: var(--calcite-font-weight-normal);
}

slot[name=panel-start]::slotted(calcite-shell-panel),
slot[name=panel-end]::slotted(calcite-shell-panel) {
  position: relative;
  z-index: calc(var(--calcite-z-index) + 1);
}

slot[name=panel-end]::slotted(calcite-shell-panel) {
  margin-inline-start: auto;
}

::slotted(calcite-panel),
::slotted(calcite-flow) {
  border-width: 1px;
  border-inline-start-width: 0px;
  border-inline-end-width: 0px;
  border-style: solid;
  border-color: var(--calcite-color-border-3);
}

slot[name=center-row]::slotted(calcite-shell-center-row:not([detached])),
slot[name=panel-top]::slotted(calcite-shell-center-row:not([detached])),
slot[name=panel-bottom]::slotted(calcite-shell-center-row:not([detached])) {
  border-inline-start-width: 1px;
  border-inline-end-width: 1px;
  border-color: var(--calcite-color-border-3);
}

.center-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  block-size: 100%;
  inline-size: 100%;
  min-inline-size: 0;
}

.content-bottom {
  justify-content: flex-end;
}

::slotted(calcite-shell-center-row) {
  flex: none;
  align-self: stretch;
}

::slotted(calcite-tip-manager) {
  position: absolute;
  z-index: var(--calcite-z-index-toast);
  box-sizing: border-box;
}

@keyframes in-up {
  0% {
    opacity: 0;
    transform: translate3D(0, 5px, 0);
  }
  100% {
    opacity: 1;
    transform: translate3D(0, 0, 0);
  }
}

::slotted(calcite-tip-manager) {
  animation: in-up var(--calcite-internal-animation-timing-slow) ease-in-out;
  border-radius: 0.25rem;
  --tw-shadow: 0 6px 20px -4px rgba(0, 0, 0, 0.1), 0 4px 12px -2px rgba(0, 0, 0, 0.08);
  --tw-shadow-colored: 0 6px 20px -4px var(--tw-shadow-color), 0 4px 12px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  inset-block-end: 0.5rem;
  inset-inline: var(--calcite-shell-tip-spacing);
}

slot[name=center-row]::slotted(calcite-shell-center-row),
slot[name=panel-bottom]::slotted(calcite-shell-center-row) {
  margin-block-start: auto;
}

slot[name=panel-top]::slotted(calcite-shell-center-row) {
  margin-block-end: auto;
}

.position-wrapper {
  position: absolute;
  pointer-events: none;
  inset: 0;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}